<template>
  <div class="form__status">
    <BAlert show :variant="alertClass">{{ statusText }}</BAlert>
  </div>
</template>

<script>
export default {
  name: 'BaseCertificationFormStatus',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: this.value
    }
  },
  computed: {
    status: function() {
      return 'compliant'
    },
    statusText: function() {
      let status = ''
      switch (this.status) {
        case 'warning':
          status = 'pomarańczowa lampka'
          break
        case 'end_form':
          status = 'Wyrzucenie z formularza'
          break
        case 'rejected':
          status = 'Nie podlega ocenie'
          break
        case 'not_compliant':
          status = 'Niezgodny'
          break
        default:
          status = 'Zgodny'
          break
      }
      return status
    },
    alertClass: function() {
      return this.status == 'compliant' ? 'success' : 'danger'
    }
  }
}
</script>
